module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "zxonz6kp",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
